import { PersonsBundlingStopService_personsBundlingStopServiceGetEntity } from '@festina/moneyin-general-types/moneyin/hooks/PersonsBundlingStopService_personsBundlingStopServiceGetEntity'

export const useFetchMoneyInPersonsBundlingStops =
  PersonsBundlingStopService_personsBundlingStopServiceGetEntity.useSuspenseQuery
